document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('.free-menu');
    const navigation = menu?.querySelector('.free-menu__navigation');
    const main = menu?.closest('main');
    const header = document.querySelector('.js-headroom');
    const sectionLinks = Array.from(navigation?.querySelectorAll('a[href*="#"]') ?? [])
        .map((link) => {
            const url = new URL(link.href, window.location.href);
            const targetId = decodeURIComponent(url.hash.slice(1));

            if (
                url.origin !== window.location.origin ||
                url.pathname !== window.location.pathname ||
                !targetId
            ) {
                return null;
            }

            const section = document.getElementById(targetId);

            return section ? { link, section } : null;
        })
        .filter(Boolean);

    if (!menu || !navigation || !main) {
        return;
    }

    let isTicking = false;

    const getStickyTop = () => {
        const headerBottom = header?.getBoundingClientRect().bottom ?? 0;

        return Math.max(headerBottom, 0) + 16;
    };

    const resetNavigationPosition = () => {
        menu.classList.remove('is-sticky');
        menu.style.removeProperty('--free-menu-sticky-top');
        menu.style.removeProperty('--free-menu-sticky-left');
        menu.style.removeProperty('--free-menu-sticky-width');
        menu.style.removeProperty('--free-menu-sticky-height');
    };

    const isMobileMenu = () => window.matchMedia('(max-width: 991px)').matches;

    const updateNavigationPosition = () => {
        if (isMobileMenu()) {
            resetNavigationPosition();
            return;
        }

        const stickyTop = getStickyTop();
        const menuRect = menu.getBoundingClientRect();
        const mainRect = main.getBoundingClientRect();
        const navigationHeight = navigation.offsetHeight;
        const shouldStick = menuRect.top <= stickyTop && mainRect.bottom > stickyTop + navigationHeight;

        if (!shouldStick) {
            resetNavigationPosition();
            return;
        }

        if (!menu.classList.contains('is-sticky')) {
            const navigationRect = navigation.getBoundingClientRect();

            menu.style.setProperty('--free-menu-sticky-left', `${navigationRect.left}px`);
            menu.style.setProperty('--free-menu-sticky-width', `${navigationRect.width}px`);
            menu.style.setProperty('--free-menu-sticky-height', `${navigationRect.height}px`);
            menu.classList.add('is-sticky');
        }

        menu.style.setProperty('--free-menu-sticky-top', `${stickyTop}px`);
    };

    const updateActiveSection = () => {
        const activationLine = getStickyTop() + navigation.offsetHeight + 24;
        let activeSection = null;

        sectionLinks.forEach((item) => {
            if (item.section.getBoundingClientRect().top <= activationLine) {
                activeSection = item;
            }
        });

        sectionLinks.forEach((item) => {
            const isActive = item === activeSection;

            item.link.classList.toggle('active', isActive);
            item.link.parentElement?.classList.toggle('active', isActive);
        });
    };

    const requestPositionUpdate = () => {
        if (isTicking) {
            return;
        }

        isTicking = true;

        window.requestAnimationFrame(() => {
            updateNavigationPosition();
            updateActiveSection();
            isTicking = false;
        });
    };

    window.addEventListener('scroll', requestPositionUpdate, { passive: true });
    window.addEventListener('resize', () => {
        resetNavigationPosition();
        requestPositionUpdate();
    });

    requestPositionUpdate();
});
